import { extendTailwindMerge } from 'tailwind-merge';

export type ClassValue = string | false | null | undefined;

// The radius scale is token-driven (tailwind.config.js): teach tailwind-merge the extra sizes so
// `rounded-full` and `rounded-circle` (or `rounded-5xl`) are treated as conflicting classes.
const twMerge = extendTailwindMerge({
  extend: { theme: { borderRadius: ['circle', '4xl', '5xl'] } },
});

/**
 * Joins class names and resolves Tailwind conflicts so that later classes win
 * (`cn('px-6', 'px-8')` → `'px-8'`). Lets callers override kit defaults via `className`.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(inputs.filter(Boolean).join(' '));
}
